export default class Store {
  constructor(initialState, name) {
    this.name = name;
    this._initialState = initialState || {};
    this._state = this._initialState;
    this._listeners = [];
    this.get = this.get.bind(this);
    this.set = this.set.bind(this);
    this.reset = this.reset.bind(this);
    this.subscribe = this.subscribe.bind(this);
  }

  get() {
    return this._state;
  }

  set(newState) {
    if (typeof newState === 'function') {
      newState = { ...this.get(), ...newState(this.get()) };
    }
    this._state = newState;
    triggerUpdates(this._listeners);
  }

  reset() {
    this.set(this._initialState);
  }

  subscribe(fn) {
    if (typeof fn !== 'function') return;
    this._listeners.push(fn);
    return () => {
      this._listeners = this._listeners.filter(f => f !== fn);
    };
  }
}

const triggerUpdates = (listeners) => {
  if (!listeners || !listeners.length) {
    return;
  }
  listeners.forEach(fn => fn());
};
